import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination } from "swiper/modules";
import React, { useEffect, useRef, useState } from "react";
import { useIsMobile } from "@/app/redux/features/device/selectors";

import "swiper/css";
import "swiper/css/pagination";
import { HouseWinnersData } from "../types";
import { getHouseCompetitionWinners } from "../house-service";

const WinnersSlider = () => {
  const isMobile = useIsMobile();

  const swiperRef = useRef<any>(null);
  const [winners, setWinners] = useState<HouseWinnersData>({
    HouseWinners: { title: "", totalPrizeWon: "", totalWinnersCount: 0, winnerCategories: [], winnerList: [] },
  });
  const [isLoading, setIsLoading] = useState<boolean>(true);
  useEffect(() => {
    getHouseWinnersData();
  }, []);
  const getHouseWinnersData = async () => {
    try {
      const response = await getHouseCompetitionWinners();
      const data = (await response.json()) as HouseWinnersData;
      setWinners(prevState => ({ ...prevState, ...data }));
    } catch (error) {
      console.error("Error fetching house winners data:", error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <div className="w-full relative pb-[26px] font-jost">
        <Swiper
          modules={[Pagination]}
          slidesPerView={1}
          loop={false}
          spaceBetween={24}
          pagination={{
            el: "#winners-pagination",
            clickable: true,
          }}
          onSwiper={swiper => (swiperRef.current = swiper)}
          className="min-w-0">
          {winners?.HouseWinners?.winnerList?.map((winner, index) => (
            <>
              <SwiperSlide key={`slide_${index}`}>
                <div
                  className={
                    "flex items-start gap-3 [background:linear-gradient(225deg,#222_2.15%,#17488D_99.45%)] pl-4 pr-8 py-6 rounded-2xl"
                  }>
                  <img
                    src={isMobile ? winner.MobilePhoto : winner.Photo}
                    alt={winner.Name}
                    width={64}
                    height={64}
                    className={"size-16 shrink-0 aspect-[1/1] rounded-full border-2 border-solid border-[#FF8200]"}
                  />
                  <div className={"flex w-full flex-col items-start gap-4"}>
                    <div
                      dangerouslySetInnerHTML={{ __html: winner.Testimonial }}
                      className={
                        "self-stretch text-white text-sm lg:text-base italic font-medium leading-5 lg:leading-5.5 line-clamp-4 lg:line-clamp-2 min-[1800px]:line-clamp-4"
                      }
                    />
                    <div className={"flex flex-col items-start self-stretch"}>
                      <div
                        className={"self-stretch text-[#FF8200] text-sm lg:text-lg font-bold leading-5 lg:leading-6"}>
                        {winner.Name}
                      </div>
                      <div
                        className={"self-stretch text-white text-sm lg:text-base font-medium leading-5 lg:leading-5.5"}>
                        {winner.Prize} {winner.CompetitionName}
                      </div>
                    </div>
                  </div>
                </div>
              </SwiperSlide>
            </>
          ))}
        </Swiper>

        <div
          id="winners-pagination"
          className="absolute !bottom-0 z-[2] !left-1/2 -translate-x-1/2 flex items-center justify-center gap-2"></div>
      </div>
    </>
  );
};

export default WinnersSlider;
